module.exports = __webpack_public_path__ + "static/img/西昆公司logo.5b201ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/西昆公司logo.png
// module id = zWOE
// module chunks = 29